module.exports = __webpack_public_path__ + "s/img/Play_M_4.33a7e187.jpg";